__turbopack_context__.v({
  "className": "work_sans_20d76fcd-module__FKFEwG__className",
  "variable": "work_sans_20d76fcd-module__FKFEwG__variable",
});
